import { Icon } from "../../../../components/BaseComponents/Icon";

export const WandIcon = (props) => (
	<Icon fill="none" viewBox="0 0 16 16" {...props}>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.35 1.73a1.12 1.12 0 0 1 1.58 0l1.34 1.34c.44.43.44 1.14 0 1.58l-2.73 2.73-.01.01-6.88 6.88c-.44.44-1.15.44-1.58 0l-1.34-1.34a1.12 1.12 0 0 1 0-1.58l9.62-9.62Zm-.24 4.39 2.26-2.26-1.23-1.23L9.88 4.9l1.23 1.23Zm-2.07-.38 1.22 1.22-6.4 6.4-1.23-1.22 6.4-6.4ZM3.8 13.42Zm.11 0Zm9.51-9.5Zm0-.12ZM5.25 1.9c.33 0 .6.27.6.6v.65h.65a.6.6 0 0 1 0 1.2h-.65V5a.6.6 0 0 1-1.2 0v-.65H4a.6.6 0 0 1 0-1.2h.65V2.5c0-.33.27-.6.6-.6Zm8.25 5.5c.33 0 .6.27.6.6v.9h.9a.6.6 0 1 1 0 1.2h-.9v.9a.6.6 0 1 1-1.2 0v-.9H12a.6.6 0 1 1 0-1.2h.9V8c0-.33.27-.6.6-.6Zm-3.4 3.5c.33 0 .6.27.6.6v.4h.4a.6.6 0 1 1 0 1.2h-.4v.4a.6.6 0 1 1-1.2 0v-.4h-.4a.6.6 0 1 1 0-1.2h.4v-.4c0-.33.27-.6.6-.6Z"
		/>
	</Icon>
);
